'use strict';

const formatString = {
  ko: {
    time: ["aa h:mm", "aa h:mm"],
    time_short: ["HH:mm", "HH:mm"],
    year: ["y\uB144", "y\uB144"],
    year_month: ["y\uB144 M\uC6D4", "y\uB144 M\uC6D4"],
    year_month_same_year: ["y\uB144 M\uC6D4", "M\uC6D4"],
    year_month_short: ["y. M", "y. M"],
    month: ["M\uC6D4", "M\uC6D4"],
    month_day: ["M\uC6D4 d\uC77C", "M\uC6D4 d\uC77C"],
    month_day_short: ["M. d", "M. d"],
    month_day_weekday: ["M\uC6D4 d\uC77C (EEE)", "M\uC6D4 d\uC77C (EEE)"],
    month_day_weekday_short: ["M. d (EEE)", "M. d (EEE)"],
    date: ["y\uB144 M\uC6D4 d\uC77C", "y\uB144 M\uC6D4 d\uC77C"],
    date_same_year: ["y\uB144 M\uC6D4 d\uC77C", "M\uC6D4 d\uC77C"],
    date_weekday: ["y\uB144 M\uC6D4 d\uC77C (EEE)", "y\uB144 M\uC6D4 d\uC77C (EEE)"],
    date_weekday_same_year: ["y\uB144 M\uC6D4 d\uC77C (EEE)", "M\uC6D4 d\uC77C (EEE)"],
    date_short: ["y. M. d", "y. M. d"],
    date_weekday_short: ["y. M. d (EEE)", "y. M. d (EEE)"],
    date_short_same_year: ["y. M. d", "M. d"],
    date_weekday_short_same_year: ["y. M. d (EEE)", "M. d (EEE)"]
  },
  en: {
    time: ["h:mm aa", "h:mm aa"],
    time_short: ["HH:mm", "HH:mm"],
    year: ["y", "y"],
    year_month: ["MMM, y", "MMM, y"],
    year_month_same_year: ["MMM", "MMM, y"],
    year_month_short: ["MMM", "MMM, y"],
    month: ["MMM", "MMM"],
    month_day: ["MMM d", "MMM d"],
    month_day_short: ["MMM d", "MMM d"],
    month_day_weekday: ["EEE, MMM d", "EEE, MMM d"],
    month_day_weekday_short: ["EEE, MMM d", "EEE, MMM d"],
    date: ["MMM d, y", "MMM d, y"],
    date_same_year: ["MMM d", "MMM d, y"],
    date_weekday: ["EEE, MMM d, y", "EEE, MMM d, y"],
    date_weekday_same_year: ["EEE, MMM d", "EEE, MMM d, y"],
    date_short: ["MMM d, y", "MMM d, y"],
    date_weekday_short: ["EEE, MMM d, y", "EEE, MMM d, y"],
    date_short_same_year: ["MMM d", "MMM d, y"],
    date_weekday_short_same_year: ["EEE, MMM d", "EEE, MMM d, y"]
  }
};
const getFormatStringForTimeRangePreset = (presetName, locale) => {
  return formatString[locale][presetName];
};

exports.getFormatStringForTimeRangePreset = getFormatStringForTimeRangePreset;
//# sourceMappingURL=getFormatStringForTimeRangePreset.cjs.map
